import { Router } from '@gatsbyjs/reach-router';
import React from 'react';
import styled, { css } from 'styled-components';
import Master, { NAV_WIDTH, Props as MasterProps } from './components/Master';
import TEST_ID_MASTER from '~/components/template/MasterDetail/components/Master/index.testid';
import { DEFAULT_BOTTOM } from '~/components/molecule/FloatingSaveBar';

export type Props = MasterProps & {};

/**
 * Master detail container.
 *
 * All children must have a corresponding `path` property to
 * work with our router.
 */
const MasterDetail: React.FCC<Props> = ({
  dataTestId,
  navbar,
  children,
  basePath,
  ...rest
}) => (
  <Container data-testid={dataTestId}>
    <Master
      dataTestId={TEST_ID_MASTER.CONTAINER}
      basePath={basePath}
      navbar={navbar}
      {...rest}
    />
    <Details>{children}</Details>
    <Spacer />
  </Container>
);

const Container = styled.div<{}>(
  () => css`
    display: grid;
    grid-template-columns: ${NAV_WIDTH} auto;
  `,
);

const Details = styled(Router)<{}>(
  () => css`
    display: flex;
    flex-grow: 1;
  `,
);

/**
 * Spacer to prevent the FloatingSaveBar from hiding the details container
 */
const Spacer = styled.div`
  height: ${DEFAULT_BOTTOM + 50}px;
`;

export default MasterDetail;
